<template>
  <el-drawer
    title="Cambio de fecha de pago"
    :append-to-body="true"
    :visible.sync="visible"
    size="25%"
    @close="cancel"
    @opened="opened"
  >
    <el-container>
      <el-main>
        <el-row>
          <el-col>
            <el-form
              ref="form"
              label-width="120px"
              v-model="form"
              v-loading="loading"
            >
              <el-form-item label-width="0">
                <label>Fecha Original</label>
                <el-date-picker
                  type="date"
                  placeholder="Fecha Original"
                  v-model="form.PostingDate"
                  disabled
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>

              <el-form-item label-width="0">
                <label>Fecha Nueva</label>
                <el-date-picker
                  type="date"
                  placeholder="Nueva Fecha"
                  v-model="form.NewPostingDate"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>

              <el-form-item label-width="0">
                <label>Monto</label>
                <el-input
                  placeholder="Monto"
                  v-model="displayAmount"
                  @focus="onFocusAmount"
                  @blur="onBlurAmount"
                  style="width: 100%"
                ></el-input>
              </el-form-item>

              <el-form-item label-width="0">
                <label>No. Cuenta</label>
                <el-input
                  placeholder="No. Cuenta"
                  v-model="form.AccountNumber"
                  style="width: 100%"
                ></el-input>
              </el-form-item>

              <el-form-item label-width="0">
                <el-button type="primary" @click="submit" size="mini"
                  >Guardar cambios</el-button
                >
                <el-button @click="cancel" size="mini">Cancelar</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
export default {
  name: "ChangePostingDateAndAmount",
  events: ["success", "error"],
  data() {
    return {
      loading: true,
      visible: false,
      displayAmount: "",
      form: {
        Type: 0,
        LookingForward: false,
        Created: "",
        Id: 0,
        RowCashFlow: null,
        CurrentRowId: 0,
        AccountNumber: "",
        AccountName: "",
        DocumentNumber: "",
        PostingDate: "",
        NewPostingDate: "",
        Amount: 0,
        Executed: false
      }
    };
  },
  methods: {
    show(data) {
      this.visible = true;
      this.form = { ...data };
      this.displayAmount = this.format(this.form.Amount);
    },
    submit() {
      this.loading = true;
      this.$http
        .post("/api/CashFlow/UpdatePostingDate", {
          AccoundRowID: this.form.Id,
          PostingDate: this.form.NewPostingDate,
          Amount: this.form.Amount,
          AccountNumber: this.form.AccountNumber
        })
        .then(() => {
          this.$notify.success({
            duration: 2000,
            message: "Registro de la cuenta actualizada",
            title: "Información",
            position: "top-left"
          });
          this.$emit("success");
        })
        .catch((error) => {
          this.$message.error("Error al consultar los Registros");
          console.error(error);
          this.cancel();
          this.$emit("error");
        })
        .finally(() => {
          this.loading = false;
          this.cancel();
        });
    },
    cancel() {
      this.visible = false;
      this.loading = true;
      this.displayAmount = "";
      this.form = {
        Type: 0,
        LookingForward: false,
        Created: "",
        Id: 0,
        RowCashFlow: null,
        CurrentRowId: 0,
        AccountNumber: "",
        AccountName: "",
        DocumentNumber: "",
        PostingDate: "",
        NewPostingDate: "",
        Amount: 0,
        Executed: false
      };
    },
    opened() {
      this.loading = false;
    },
    onFocusAmount() {
      this.displayAmount = this.unformat(this.displayAmount);
    },
    onBlurAmount() {
      this.form.Amount = this.unformat(this.displayAmount);
      this.displayAmount = this.format(this.form.Amount);
    },
    format(v) {
      return (+v || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    unformat(v) {
      return v ? v.toString().replace(/,/g, "") : "";
    }
  }
};
</script>
